import { DotVariantType } from '../variants';
export const getDefaultStyles = (FOUNDATIONS, FONT) => {
    return {
        [DotVariantType.DEFAULT]: {
            container: {
                justify_content: 'center',
                align_items: 'center',
                display: 'inline-flex',
                background_color: FOUNDATIONS.color_secondary_bg_50,
                border_radius: FOUNDATIONS.radius_1000,
            },
        },
    };
};
//# sourceMappingURL=default.js.map